import HomeRouter from './Home';
import CompsRouter from './Comps';
import AccountController from './Account';
import TippingRouter from './Tipping';
import OnboardingRouter from './Onboarding';
import ActivateGameRouter from './ActivateGame';
import HelpRouter from './Help';
import StreakRouter from './Streak';
import PreseasonRouter from './Preseason';
import PasswordRouter from './Password';
import Rankings from './Rankings';

export {
	HomeRouter,
	CompsRouter,
	AccountController,
	TippingRouter,
	OnboardingRouter,
	ActivateGameRouter,
	HelpRouter,
	StreakRouter,
	PreseasonRouter,
	PasswordRouter,
	Rankings
};

export default {
	HomeRouter,
	CompsRouter,
	AccountController,
	TippingRouter,
	OnboardingRouter,
	ActivateGameRouter,
	HelpRouter,
	StreakRouter,
	PreseasonRouter,
	PasswordRouter,
	Rankings
}